
/**
 * Haptic Feedback Utility
 * 
 * Provides haptic feedback using the Web Vibration API.
 * Safe to use in browsers that don't support vibration (no-op).
 */

export const hapticTap = () => {
    if (typeof navigator !== 'undefined' && navigator.vibrate) {
        // Short vibration for tap feedback (10-15ms is typical for 'light' tap)
        try {
            navigator.vibrate(15);
        } catch (e) {
            // Ignore errors (e.g. if simple vibration is not allowed in context)
        }
    }
};
